// extracted by mini-css-extract-plugin
module.exports = {"bottom-content":"_1410bfd27b--bottom-content--aimmI","factoid":"_1410bfd27b--factoid--SR4Sm","description":"_1410bfd27b--description--YDVRt"};